import { Observable } from "rxjs";
import { DynamicCol } from "./dynamic-col.model";

export class DynamicColTemplate<T> extends DynamicCol<T> {

    property!: string;
    dataObserver?: Observable<T>;
    toType: 'generic' | 'item' | 'object';

    constructor(source: Partial<DynamicColTemplate<T>>) {
        super(source);
        this.type = "template";
        this.toType = "item";
        Object.assign(this, source);
    }
}